module.exports = __webpack_public_path__ + "img/logoLS.55ce61ec.png";